import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "27",
  height: "27",
  viewBox: "0 0 27 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.80015 4.80059C4.80015 4.13819 5.33775 3.60059 6.00015 3.60059C6.66255 3.60059 7.20015 4.13819 7.20015 4.80059V6.00059H19.2001V4.80059C19.2001 4.13819 19.7377 3.60059 20.4001 3.60059C21.0625 3.60059 21.6001 4.13819 21.6001 4.80059V6.00059C22.9261 6.00059 24.0001 7.07459 24.0001 8.40059V21.6006C24.0001 22.9266 22.9261 24.0006 21.6001 24.0006H4.80015C3.47415 24.0006 2.40015 22.9266 2.40015 21.6006V8.40059C2.40015 7.07459 3.47415 6.00059 4.80015 6.00059V4.80059ZM4.80015 12.0006C4.80015 11.3382 5.33775 10.8006 6.00015 10.8006H20.4001C21.0625 10.8006 21.6001 11.3382 21.6001 12.0006V20.4006C21.6001 21.063 21.0625 21.6006 20.4001 21.6006H6.00015C5.33775 21.6006 4.80015 21.063 4.80015 20.4006V12.0006ZM16.8 18.0002C16.8 17.3378 17.3376 16.8002 18 16.8002C18.6625 16.8002 19.2001 17.3378 19.2001 18.0002C19.2001 18.6626 18.6625 19.2002 18 19.2002C17.3376 19.2002 16.8 18.6626 16.8 18.0002Z",
  fill: "#2B3951"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("mask", {
  id: "mask0_1302_33172",
  style: {"mask-type":"luminance"},
  maskUnits: "userSpaceOnUse",
  x: "2",
  y: "3",
  width: "23",
  height: "22"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.80015 4.80059C4.80015 4.13819 5.33775 3.60059 6.00015 3.60059C6.66255 3.60059 7.20015 4.13819 7.20015 4.80059V6.00059H19.2001V4.80059C19.2001 4.13819 19.7377 3.60059 20.4001 3.60059C21.0625 3.60059 21.6001 4.13819 21.6001 4.80059V6.00059C22.9261 6.00059 24.0001 7.07459 24.0001 8.40059V21.6006C24.0001 22.9266 22.9261 24.0006 21.6001 24.0006H4.80015C3.47415 24.0006 2.40015 22.9266 2.40015 21.6006V8.40059C2.40015 7.07459 3.47415 6.00059 4.80015 6.00059V4.80059ZM4.80015 12.0006C4.80015 11.3382 5.33775 10.8006 6.00015 10.8006H20.4001C21.0625 10.8006 21.6001 11.3382 21.6001 12.0006V20.4006C21.6001 21.063 21.0625 21.6006 20.4001 21.6006H6.00015C5.33775 21.6006 4.80015 21.063 4.80015 20.4006V12.0006ZM16.8 18.0002C16.8 17.3378 17.3376 16.8002 18 16.8002C18.6624 16.8002 19.2001 17.3378 19.2001 18.0002C19.2001 18.6626 18.6624 19.2002 18 19.2002C17.3376 19.2002 16.8 18.6626 16.8 18.0002Z",
    fill: "white"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("g", { mask: "url(#mask0_1302_33172)" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render };